<template>
  <div class="container container-shadow login-container verify-code-login-container">
      <el-form :model="formVal" :rules="formRules" ref="formVal" class="login-box" @submit.native.prevent>
        <h2>Safety confirmation</h2>
        <p class="verify-code-login-tips">Sending passcode to your mobile number ({{phone}})</p>
        <el-form-item prop="emailCode" class="form-row">
            <el-input v-model="formVal.emailCode" placeholder="Mobile passcode" auto-complete="off"></el-input>
        </el-form-item>
        <div class="seconds"><span class="num">{{wait}}</span>s <el-button @click="sendCode" class="reset-passcode" :disabled="isResendDisabled">Resend passcode</el-button></div>
        <div class="form-row form-button">
          <el-button @click="submitForm('formVal')" :disabled="isDisabled">Login</el-button>
        </div> 
      </el-form>
  </div>
</template>

<script>
import { validatePass } from 'utils/validate'
import { loginBySms, loginSendSms } from 'service/login'
export default {
  data() {
    return {
      wait: 60,
      isDisabled: true,
      isResendDisabled: false,
      formVal: {
        emailCode: ''
      },
      formRules: {
        emailCode: [{ required: true, message: 'Required.', trigger: 'blur' }]
      }
    }
  },
  created() {
    window.vuex_store.commit('set_title', 'Login')
    this._cutTime()
    console.log(this.$route.params)
    this.phone = this.$route.params.phone
    this.email = this.$route.params.email
  },
  methods: {
    _cutTime() {
      this.isResendDisabled = true
      let timenum = () => {
        if (this.wait === 0) {
          this.wait = 60
          this.isResendDisabled = false
        } else {
          setTimeout(() => {
            this.wait--
            timenum()
          }, 1000)
        }
      }
      timenum()
    },
    sendCode() {
      if (this.email) {
        loginSendSms({ email: this.email }).then(data => {
          this._cutTime()
          this.isResendDisabled = true
        })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          loginBySms({ email: this.email, code: this.formVal.emailCode }).then(
            res => {
              localStorage.uk_token = res.token
              this.$router.push({ name: 'memberIndex' })
            }
          )
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  },
  watch: {
    formVal: {
      handler(newVal, oldVal) {
        // 是否禁用提交按钮
        this.$refs.formVal.validate(valid => {
          this.isDisabled = !valid
        })
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.verify-code-login-container {
  height: 364px;
  h2 {
    font-size: 30px;
    line-height: 30px;
    color: #333333;
    line-height: 1;
    text-align: center;
  }
  .verify-code-login-tips {
    line-height: 1;
    color: #333333;
    text-align: center;
    margin-top: 8px;
  }
  .form-row {
    margin-top: 30px;
  }
  .reset-passcode {
    cursor: pointer;
    padding: 0;
    border: none;
    &:disabled,
    span {
      color: #999999;
    }
    &.el-button:focus,
    &.el-button:hover {
      color: #999999;
      border-color: transparent;
      background-color: transparent;
      text-decoration: underline;
    }
  }
  .seconds {
    text-align: right;
    color: #999999;
    line-height: 1;
    margin-top: -10px;
    .num {
      color: $color-primary;
    }
  }
}
</style>
